import { Component, Input, OnInit } from '@angular/core';
import { ShoppingProducts } from '../interfaces/ShoppingProductsItem';
import { NzDrawerRef } from 'ng-zorro-antd/drawer';
import { NzMessageService } from 'ng-zorro-antd/message';
import { Line } from '../interfaces/cartObject';

interface SerialEntry {
  serial: string;
  useMainPBX: boolean;
}

@Component({
  selector: 'app-snchooser',
  templateUrl: './snchooser.component.html',
  styleUrls: ['./snchooser.component.less'],
})
export class SNChooserComponent implements OnInit {
  @Input() product: ShoppingProducts;
  @Input() item: Line;

  serialType: string;
  serialCount = 1;

  serials: string[] = [];
  useMainPBX: boolean[] = [];

  yeastarId = '';

  serialRegex = /^[A-Za-z][A-Za-z0-9]*$/;
  emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  trackByIndex = (i: number) => i;

  constructor(
    private message: NzMessageService,
    private drawerRef: NzDrawerRef
  ) {}

  ngOnInit(): void {
    console.log('this.item>>', this.item);
    this.serialType = this.product.SerialType;
    this.serialCount = this.product.SelectedQuantity;
    if (
      (this.product.SerialOptions == null ||
        this.product.SerialOptions === undefined) &&
      this.item != null &&
      this.item !== undefined
    ) {
      this.product.SerialOptions = this.item.productLine.SerialOptions;
    }

    if (
      this.product.SerialOptions !== null &&
      this.product.SerialOptions !== undefined &&
      this.product.SerialOptions !== ''
    ) {
      this.loadSavedSerial(this.product.SerialOptions);
    } else {
      // fallback: load empty inputs
      this.fillDefaultSerials();
    }
  }

  fillDefaultSerials(): void {
    this.serials = Array(this.serialCount).fill('');
    this.useMainPBX = Array(this.serialCount).fill(false);
  }

  loadSavedSerial(value: string | null | undefined): void {
    if (!value) return;

    try {
      const parsed: SerialEntry[] = JSON.parse(value);
      if (Array.isArray(parsed)) {
        this.serials = parsed.map((s) => s.serial);
        this.useMainPBX = parsed.map((s) => s.useMainPBX);

        const diff = this.serialCount - this.serials.length;
        if (diff > 0) {
          for (let i = 0; i < diff; i++) {
            this.serials.push('');
            this.useMainPBX.push(false);
          }
        }
        return;
      }
    } catch {
      this.yeastarId = value;
    }
  }

  toggleCheckbox(i: number): void {
    if (this.useMainPBX[i]) {
      // clear and disable this serial input
      this.serials[i] = '';
    }
  }

  deleteSerial(index: number): void {
    this.serials.splice(index, 1);
    this.useMainPBX.splice(index, 1);
  }

  canSubmit(): boolean {
    return !(this.serialType === 'S' && this.serials.length > this.serialCount);
  }

  /*validateSerials(): boolean {
    for (let i = 0; i < this.serialCount; i++) {
      if (this.useMainPBX[i]) continue; // skip disabled ones
      const s = this.serials[i] || '';
      if (s !== '') {
        if (!this.serialRegex.test(s) || s.length !== 12) {
          this.message.error(
            `Serial ${
              i + 1
            } is invalid. It must start with a letter, contain only letters/numbers, and be exactly 12 characters long.`
          );
          return false;
        }
      }
    }
    return true;
  }*/

  validateSerials(): boolean {
    for (let i = 0; i < this.serialCount; i++) {
      if (this.useMainPBX[i]) continue; // skip disabled ones
      const s = this.serials[i]?.trim() || '';

      // Only validate if there’s a value
      if (s !== '') {
        const hasLetter = /[A-Za-z]/.test(s);
        const hasNumber = /\d/.test(s);

        if (s.length !== 12 || !hasLetter || !hasNumber) {
          this.message.error(
            `Serial ${
              i + 1
            } is invalid. It must be exactly 12 characters and contain both letters and numbers.`
          );
          return false;
        }
      }
    }
    return true;
  }

  validateEmail(): boolean {
    const email = this.yeastarId.trim();
    if (email !== '' && !this.emailRegex.test(email)) {
      this.message.error('Please enter a valid Yeastar ID (email address).');
      return false;
    }
    return true;
  }

  onSubmit(): void {
    if (this.serialType === 'SO' || this.serialType === 'SN') {
      if (this.serials.length > this.serialCount) {
        this.message.error('Too many serials, please delete extra ones.');
        return;
      }
      if (!this.validateSerials()) return;

      const result: SerialEntry[] = [];
      for (let i = 0; i < this.serialCount; i++) {
        result.push({
          serial: this.serials[i] || '',
          useMainPBX: this.useMainPBX[i] || false,
        });
      }
      console.log('Serials JSON:', JSON.stringify(result));
      this.product.SerialOptions = JSON.stringify(result);
    } else {
      if (!this.validateEmail()) return;
      console.log('Yeastar ID:', this.yeastarId);
      this.product.SerialOptions = this.yeastarId;
    }

    this.drawerRef.close();
  }
}
